import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import throttle from "lodash/throttle";
import App from "./App";
import { store } from "./store/store";
import * as serviceWorker from "./serviceWorker";
import { setAuthStateToStorage } from "./services/utilities/storage";

store.subscribe(
  throttle(() => {
    const authState = store.getState().auth;
    authState.token &&
      setAuthStateToStorage({
        token: authState.token,
        refreshToken: authState.refreshToken,
        user: { ...authState.user }
      });
  }),
  1000
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
